<template>
    <van-form class="default-form" ref="exportInvoice" @failed="onFailed" @submit="onSubmit" :show-error="false">

        <van-field v-model="exportInvoice.num" placeholder="请输入出口发票的发票号码" input-align="right"
                   error-message-align="right" clearable
                   :rules="rules.numRule" class="van-field-border van-field-required">
            <span slot="label">发票号码<i class="extra-cont">Invoice NO</i> </span>
        </van-field>

        <van-field v-model="exportInvoice.time" placeholder="请输入发票日期" input-align="right" error-message-align="right"
                   :rules="rules.timeRule" :readonly="true" class="van-field-border van-field-required"
                   @click="timeVisible = true">
            <span slot="label">发票日期<i class="extra-cont">Invoice Date</i></span>
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field label="发票金额" placeholder="请输入发票金额" v-model="exportInvoice.amount" input-align="right"
                   type="number" error-message-align="right"
                   :rules="rules.amountRule" clearable class="van-field-border van-field-required"></van-field>

        <van-field v-model="exportInvoice.currencyLabel" label="发票币种" placeholder="请输入发票币种" input-align="right" error-message-align="right"
                   :rules="rules.currencyRule" :readonly="true" class="van-field-border van-field-required"
                   @click="currencyVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field v-model="exportInvoice.provision" label="价格条款" placeholder="请选择价格条款" input-align="right" error-message-align="right"
                   :rules="rules.provisionRule" :readonly="true" class="van-field-border van-field-required"
                   @click="provisionVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

      <van-field label="价格条款详情" placeholder="请输入价格条款详情" v-model="exportInvoice.provisionDetail" input-align="left"
                 type="textarea" rows="1"
                 error-message-align="right"
                 clearable class="van-field-border van-field-textarea">
      </van-field>

        <van-row type="flex" class="form-footer">
            <van-row type="flex">
              <i class="form-footer-save-add"></i>
              <van-button native-type="button" @click="handleCancel">取消</van-button>
            </van-row>
            <van-row type="flex">
              <i class="form-footer-save"></i>
              <van-button native-type="submit">保存</van-button>
            </van-row>
        </van-row>

        <!--发票日期-->
        <van-popup v-model="timeVisible" position="bottom">
            <date-picker @close="timeVisible = false" @confirm="timeConfirm"></date-picker>
        </van-popup>

        <!--发票币种-->
        <van-popup v-model="currencyVisible" position="bottom">
            <common-picker @close="currencyVisible = false" @confirm="currencyConfirm"
                           :columns="currencyOptions"></common-picker>
        </van-popup>

        <!--价格条款-->
        <van-popup v-model="provisionVisible" position="bottom">
            <common-picker @close="provisionVisible = false" @confirm="provisionConfirm"
                           :columns="provisionOptions"></common-picker>
        </van-popup>

    </van-form>
</template>

<script>
    import {eventBus} from "@zhoujianhui/vip-core"
    import DatePicker from "../../../component/DatePicker"
    import CommonPicker from '../../../component/CommonPicker'
    import ExportInvoice from '../../../origin-certificate/dto/ExportInvoice'
    import dictionaryService from "../../../component/dictionary-service"

    export default {
        name: "exportInvoice",
        components: {
            DatePicker, CommonPicker
        },
        data() {
            return {
                timeVisible: false,
                currencyVisible: false,
                provisionVisible: false,

                exportInvoice: new ExportInvoice(),
                rules: ExportInvoice.getRules(),

                currencyOptions: [],
                provisionOptions: [],
                exportInvoiceErrors: null
            }
        },
        created() {
            this.exportInvoice.currency = "USD";
            this.exportInvoice.currencyLabel = "USD(502)";
            this.loadDictionaryOptions();
        },
        methods: {
            async loadDictionaryOptions() {
                const result = await dictionaryService.getDictionaryIncludeItemsByIds([2, 13]);
                if (result.isSuccess()) {
                    this.currencyOptions = result.data.find(item => item.id == 13).items.filter(item => item.enabled);
                    this.provisionOptions = result.data.find(item => item.id == 2).items.filter(item => item.enabled);
                }
            },
            timeConfirm(selectedTime) {
                this.exportInvoice.time = selectedTime;
                this.timeVisible = false;

            },
            currencyConfirm(selectedCurrency) {
                this.exportInvoice.currency = selectedCurrency.value;
                this.exportInvoice.currencyLabel = selectedCurrency.label;
                this.currencyVisible = false;
            },
            provisionConfirm(selectedProvision) {
                this.exportInvoice.provision = selectedProvision.value;
                this.exportInvoice.provisionLabel = selectedProvision.label;
                this.provisionVisible = false;
            },
            validate() {
                return this.$refs["exportInvoice"].validate().then(() => {
                    return new Promise(resolve => resolve(true))
                }).catch(() => {
                        return new Promise(resolve => resolve(false))
                    }
                )
            },
            onFailed(error) {
                this.exportInvoiceErrors = error;
            },
            handleCancel() {
                this.$emit('close');
            },
            onSubmit() {
                eventBus.$emit('addExportInvoice', this.exportInvoice);
                this.$emit('close');
            }
        }
    }
</script>
